const newsletter = () => {
	if (document.querySelector('.newsletter form')) {
		const formEl = document.querySelector('.newsletter form');
		const messages = formEl.querySelector('.newsletter__messages');
		const submitButton = formEl.querySelector('.newsletter__button');

		const animateButton = (status) => {
			submitButton.classList.add(status);
			submitButton.classList.remove('animate');
			submitButton.classList.add('animate');
			setTimeout(() => {
				submitButton.classList.remove('animate');
				submitButton.classList.remove(status);
			}, 6000);
		};

		const postData = (form) => {
			const formData = new FormData(form);
			fetch(form.getAttribute('action'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(Object.fromEntries(formData)),
			})
				.then((response) => response.json())
				.then((result) => {
					if (result.status) {
						animateButton(result.status);
						messages.insertAdjacentHTML('afterbegin', `<p class="is-${result.status}">${result.message}</p>`);
					}
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		};

		formEl.addEventListener('submit', (event) => {
			event.preventDefault();
			if (event.target.checkValidity()) {
				messages.innerHTML = '';
				postData(formEl);
			}
		});
	}
};

export default newsletter;
